/* eslint-disable vue/no-deprecated-filter */
<template>
  <li :class="{ close: !mode }" @click="taskDetail(tId)">
    <h3>{{ task }}</h3>
    <p>{{ description }}</p>
    <div class="box">
      <label>Assign To</label>
      <span class="selectedName" v-for="asign in assignTo" :key="asign">{{
        asign.name
      }}</span>
    </div>
    <span>{{ date }}</span>
  </li>
</template>

<script>
export default {
  props: ["id", "task", "description", "mode", "date", "tId", "assignTo"],
  data() {
    return {
      replie: "",
      details: null,
    };
  },
  emits: ["task-detail"],
  methods: {
    taskDetail(tid) {
      this.$emit("task-detail", tid);
    },
  },
};
</script>

<style scoped>
.selectedName {
  background: #313131;
  padding: 4px 10px;
  margin-right: 10px;
  color: #fff;
  border-radius: 2px;
}
.box {
  margin-bottom: 15px;
  background: #f1f1f1;
}
.box label {
  width: 100%;
  float: left;
  margin-bottom: 10px;
  font-weight: bold;
}
li,
.box {
  list-style: none;
  width: 100%;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #c1c1c1;
  box-sizing: border-box;
  padding: 20px;
  float: left;
  margin-top: -1px;
}
li ul li {
  padding: 5px;
  margin-bottom: 10px;
  float: left;
  width: 100%;
  box-sizing: border-box;
}
li ul {
  margin: 20px 0px;
  padding: 0px;
  float: left;
  width: 100%;
  box-sizing: border-box;
}
li ul li:last-child {
  margin-bottom: 0px;
}
.reply {
  width: 100%;
  float: left;
}
.inputbox {
  float: left;
  width: 70%;
}
.inputbox textarea {
  width: 100%;
  border: 1px solid #c1c1c1;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  float: left;
}
.btn {
  float: right;
  text-align: right;
  width: 30%;
}
.close {
  background-color: salmon;
}
</style>
